export const DELETE_COMPONENT_STARTED = 'ui.delete.DELETE_COMPONENT_STARTED' as const;
export type DeleteComponentStartedPayload = {
	id: string;
};
export type DeleteComponentStartedAction = {
	type: typeof DELETE_COMPONENT_STARTED;
	payload: DeleteComponentStartedPayload;
};
export const deleteComponentStarted = (
	payload: DeleteComponentStartedPayload,
): DeleteComponentStartedAction => ({
	type: DELETE_COMPONENT_STARTED,
	payload,
});

export const DELETE_COMPONENT_DIALOG_DISPLAYED =
	'ui.delete.DELETE_COMPONENT_DIALOG_DISPLAYED' as const;
export type DeleteComponentDialogDisplayedPayload = {
	id: string;
};
export type DeleteComponentDialogDisplayedAction = {
	type: typeof DELETE_COMPONENT_DIALOG_DISPLAYED;
	payload: DeleteComponentDialogDisplayedPayload;
};
export const deleteComponentDialogDisplayed = (
	payload: DeleteComponentDialogDisplayedPayload,
): DeleteComponentDialogDisplayedAction => ({
	type: DELETE_COMPONENT_DIALOG_DISPLAYED,
	payload,
});

export const DELETE_COMPONENT_CANCEL = 'ui.delete.DELETE_COMPONENT_CANCEL' as const;
export type DeleteComponentCancelPayload = {
	id: string;
};
export type DeleteComponentCancelAction = {
	type: typeof DELETE_COMPONENT_CANCEL;
	payload: DeleteComponentCancelPayload;
};
export const deleteComponentCancel = (
	payload: DeleteComponentCancelPayload,
): DeleteComponentCancelAction => ({
	type: DELETE_COMPONENT_CANCEL,
	payload,
});

export type Action =
	| DeleteComponentStartedAction
	| DeleteComponentDialogDisplayedAction
	| DeleteComponentCancelAction;
